export default {
  '/': {
    title:
      'Bilyoner: Canlı İddaa, Şans Oyunları, TJK At Yarışı ve Spor Toto',
    description:
      'Bahsin ilk adresi Bilyoner’de iddaa, şans oyunları ve canlı bahis heyecanını yaşa. Yapay zeka iddaa tahminleri, uzman yorumları, Spor Toto ve At yarışını keşfet.',
  },
  '/iddaa': {
    title: 'İddaa Bilyoner’de Oynanır: İddaa Programı & İddaa Bülteni',
    description:
      'İddaa programı, iddaa bülteni ve iddaa oranlarını takip etme, kazandıran iddaa tahminleriyle bahis heyecanını iddaa oynayarak yaşama fırsatı Bilyoner’de!',
  },
  '/iddaa/basketbol': {
    title: 'Basketbol İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Basketbol İddaa sonuçlarını & en güncel basketbol İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/voleybol': {
    title: 'Voleybol İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Voleybol İddaa sonuçlarını & en güncel voleybol İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/hentbol': {
    title: 'Hentbol İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Hentbol İddaa sonuçlarını & en güncel hentbol İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/tenis': {
    title: 'Tenis İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Tenis İddaa sonuçlarını & en güncel tenis İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/zirve-oran': {
    title: 'Zirve Oran İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Zirve Oran İddaa sonuçlarını & en güncel tenis İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/e-futbol': {
    title: 'İddaa e-futbol Oyna - Bilyoner',
    description:
      "İddaa E-Futbol, artık Bilyoner'de! E-Futbol maçların sonuçlarını anında takip edebilir, E-Futbol maç listesinden seçim yaparak kuponlarınızı hazırlayabilirsiniz."
  },
  '/iddaa/amerikan-futbol': {
    title: 'İddaa Amerikan Futbol Oyna - Bilyoner',
    description:
      "İddaa Amerikan Futbol, artık Bilyoner'de! Amerikan Futbol maçların sonuçlarını anında takip edebilir, Amerikan Futbol maç listesinden seçim yaparak kuponlarınızı hazırlayabilirsiniz."
  },
  '/iddaa/e-basketbol': {
    title: 'İddaa e-Basketbol Oyna - Bilyoner',
    description:
      "İddaa E-Basketbol, artık Bilyoner'de! E-Basketbol maçların sonuçlarını anında takip edebilir, E-Basketbol maç listesinden seçim yaparak kuponlarınızı hazırlayabilirsiniz."
  },
  '/iddaa/snooker': {
    title: 'Snooker İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Snooker İddaa sonuçlarını & en güncel snooker İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/masa-tenisi': {
    title: 'Masa Tenisi İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Buz masa tenisi sonuçlarını & en güncel masa tenisi İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/buz-hokeyi': {
    title: 'Buz Hokeyi İddaa Bülteni & Tahminleri - Bilyoner',
    description:
      'Buz hokeyi İddaa sonuçlarını & en güncel buz hokeyi İddaa bültenini takip etmek, anlık skorlara erişmek ve İddaa oynamak için Bilyoner sizinle!',
  },
  '/iddaa/mma': {
    title: 'MMA – Dövüş Sanatları Spor Bahisleri & Sonuçları – Bilyoner',
    description:
      'Karışık Dövüş Sanatları (MMA) iddaa programı ve geniş bülteni görmek, canlı iddaa sonuçlarını takip etmek, MMA maçlarına bahis yapmak için hemen tıklayın!'
  },
  '/iddaa/duello': {
    title: 'İddaa Düello Oyna - Bilyoner',
    description:
      "İddaa Düello, artık Bilyoner'de! Düello maçların sonuçlarını anında takip edebilir, Düello maç listesinden seçim yaparak kuponlarınızı hazırlayabilirsiniz."
  },
  '/iddaa/counter-strike-global-offence': {
    title:
      'Counter Strike Global Offence İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Counter Strike Global Offence İddaa, Bahsin İlk Adresi Bilyoner’de! Counter Strike Global Offence İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/league-of-legends': {
    title: 'League of Legends İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'League of Legends İddaa, Bahsin İlk Adresi Bilyoner’de! League of Legends İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/dota-2': {
    title: 'Dota 2 İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Dota 2, Bahsin İlk Adresi Bilyoner’de! Dota 2 İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/starcraft-2': {
    title: 'Starcraft 2 İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Starcraft 2 İddaa, Bahsin İlk Adresi Bilyoner’de! Starcraft 2 İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/hearthstone': {
    title: 'Hearthstone İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Hearthstone İddaa, Bahsin İlk Adresi Bilyoner’de! Hearthstone İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/call-of-duty': {
    title: 'Call of Duty İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Call of Duty İddaa, Bahsin İlk Adresi Bilyoner’de! Call of Duty İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/iddaa/overwatch': {
    title: 'Overwatch İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Overwatch İddaa, Bahsin İlk Adresi Bilyoner’de! Overwatch İddaa Bülteni, Canlı Yayınlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/kupon-emri': {
    title: 'Kupon Emri | Bilyoner',
    description:
      'Kupon Emri ile Bahis Kaçırma! Sporda Eğlencenin Adresi Bilyoner’de İddaa Oyna, Canlı Bahis Yap Heyecanını Katla! İddaa Bilyoner’de Oynanır!'
  },
  '/iddaa/populer-bahisler': {
    title: 'Popüler Bahisler & En Çok Oynanan Maçlar - Bilyoner',
    description:
      "Popüler bahisler Bilyoner'de oynanır! En çok oynanan maçların iddaa programı, iddaa maç tahminleri ve hazır iddaa kuponları Bilyoner'de seni bekliyor."
  },
  '/iddaa/populer-bahisler/basketbol': {
    title: 'Basketbol En Çok Oynanan Maçlar & Popüler Bahisler - Bilyoner',
    description:
      "Popüler bahisler Bilyoner’de oynanır! En çok oynanan basketbol maçların iddaa programı, iddaa maç tahminleri ve hazır iddaa kuponları Bilyoner'de; hemen tıkla!"
  },
  '/iddaa/populer-bahisler/tenis': {
    title: 'En Popüler Tenis Bahisleri - Bilyoner',
    description:
      "En popüler tenis bahsi maçları Bilyoner'de sizler için listeleniyor! En çok oynanan tenis karşılaşmalarını incelemek ve kazanan olmak için hemen tıklayın."
  },
  '/iddaa/sana-ozel-maclar/canli': {
    title: 'Sana Özel Canlı Maçlar - Bilyoner',
    description:
      "Sana özel canlı maçlar ve iddaa kuponları Bilyoner'de! Sana özel maçları kaçırmamak için hemen tıkla."
  },
  '/iddaa/sana-ozel-maclar/yakinda-baslayacak': {
    title: 'Sana Özel Yakında Başlayacak Maçlar - Bilyoner',
    description:
      "Sana özel yakında başlayacak maçlar ve iddaa kuponları Bilyoner'de! Sana özel maçları kaçırmamak için hemen tıkla."
  },
  '/iddaa/trend-olan-maclar/canli': {
    title: 'Son Dakika Popüler İddaa Kuponları - Bilyoner',
    description:
      "En popüler iddaa kuponları Bilyoner'de! Son 15 dakika içerisinde en çok oynanan popüler bahisleri incelemek için hemen tıklayın!"
  },
  '/iddaa/trend-olan-maclar/yakinda-baslayacak': {
    title: 'Yakında Başlayacak Popüler İddaa Kuponları - Bilyoner',
    description:
      "Yakında başlayacak olan popüler maç ve iddaa kuponları Bilyoner'de! Farklı liglerde son 1 saat içinde en çok oynanan bahisleri incelemek için hemen tıklayın!"
  },
  '/iddaa/uzun-vadeli-futbol': {
    title: 'Uzun Vadeli Futbol İddaa Programı - Bilyoner',
    description:
      'Uzun vadeli İddaa Bilyoner’de oynanır! Uzun vadeli futbol İddaa programı ve İddaa futbol maç sonuçları Bilyoner’de sizinle.',
  },
  '/iddaa/uzun-vadeli-basketbol': {
    title: 'Uzun Vadeli Basketbol İddaa Programı - Bilyoner',
    description:
      'Uzun vadeli basketbol İddaa Bilyoner’de oynanır! Uzun vadeli basketbol İddaa programı ve İddaa basketbol maç sonuçları Bilyoner’de sizinle.',
  },
  '/iddaa/uzun-vadeli-tenis': {
    title: 'Uzun Vadeli Tenis İddaa Programı - Bilyoner',
    description:
      'Uzun vadeli tenis İddaa Bilyoner’de oynanır! Uzun vadeli tenis İddaa programı ve İddaa tenis maç sonuçları Bilyoner’de sizinle.',
  },
  '/iddaa/uzun-vadeli-hentbol': {
    title: 'Uzun Vadeli Hentbol İddaa Programı | Bilyoner',
    description:
      'Uzun vadeli hentbol iddaa Bilyoner’de oynanır! Hentbol iddaa programı, iddaa maç sonuçları ve canlı maç yayını ile Bilyoner’de şans her an yanında.',
  },
  '/iddaa/uzun-vadeli-snooker': {
    title: 'Uzun Vadeli Snooker Programı İddaa Programı | Bilyoner',
    description:
      'Uzun vadeli snooker iddaa Bilyoner’de oynanır! Snooker iddaa programı, iddaa maç sonuçları ile Bilyoner’de şans her an yanınızda.',
  },
  '/iddaa/uzun-vadeli-motor-sporlari': {
    title: 'Uzun Vadeli Motor Sporları İddaa Programı - Bilyoner',
    description:
      'Uzun vadeli motor sporları İddaa Bilyoner’de oynanır! Uzun vadeli motor sporları İddaa programı ve İddaa motor sporları sonuçları Bilyoner’de sizinle.',
  },
  '/iddaa/uzun-vadeli-masa-tenisi': {
    title: 'Uzun Vadeli Masa Tenisi İddaa Programı | Bilyoner',
    description:
      'Uzun Vadeli Masa Tenisi’nde İddaa, Bahsin İlk Adresi Bilyoner’de! Uzun Vadeli masa tenisi iddaa programı, canlı maç sonuçları ve canlı maç yayını ile Bilyoner’de!',
  },
  '/iddaa/uzun-vadeli-buz-hokeyi': {
    title: 'Uzun Vadeli Buz Hokeyi İddaa Programı | Bilyoner',
    description:
      'Uzun vadeli Buz Hokeyi’nde iddaa Bilyoner’de oynanır! Uzun Vadeli Buz Hokeyi iddaa programı ve ve canlı maç yayını ile Bilyoner’de şans her an yanında.',
  },
  '/iddaa/uzun-vadeli-mma': {
    title: 'Uzun Vadeli MMA İddaa Programı | Bilyoner',
    description:
      'Uzun vadeli MMA iddaa Bilyoner’de oynanır! Uzun Vadeli MMA iddaa programı, canlı maç sonuçları ve canlı maç yayını ile Bilyoner’de şans her an yanında.',
  },
  '/iddaa/uzun-vadeli-olimpiyatlar': {
    title:
      'Tokyo Yaz Olimpiyatları - Geniş İddaa Programı & Bülteni - Bilyoner',
    description:
      'Tokyo Yaz Olimpiyatları İddaa Sonuçlarını öğrenmek; en güncel Uzun Vadeli İddaa Bültenini takip etmek ve Canlı İddaa Oynamak için Bilyoner sizinle!',
  },
  '/iddaa/favorilerim': {
    title: 'Favorilerim - İddaa - Bilyoner',
    description:
      'İddaa bültenindeki favorileriniz, dilediğiniz an kolaylıkla kupon yapabilmeniz ve bahis oluşturabilmeniz için Favorilerim altında sizi bekliyor.',
  },
  '/canli-iddaa/favorilerim': {
    title: 'Favorilerim - Canlı İddaa Oyna - Bilyoner',
    description:
      'Canlı İddaa oynarken yakın takibe almak istediğiniz ve favorilerinize eklediğiniz maçları Favorilerim alanında bulabilirsiniz.',
  },
  '/canli-iddaa': {
    title: 'Canlı İddaa, Canlı Bahis & Canlı İddaa Oyna  - Bilyoner',
    description:
      "Canlı iddaa ile spor karşılaşmalarından kazançlı çıkın! Futbol, basketbol, tenis gibi pek çok daldaki canlı bahis heyecanı şimdi Bilyoner'de sizi bekliyor.",
  },
  '/canli-iddaa/futbol': {
    title: 'Futbol Canlı İddaa Oyna - Bilyoner',
    description:
      "Futbol canlı iddaa karşılaşmalarını takip ederek şimdi oynanan maçlara kupon hazırlayın! Değişen oranlarıyla futbol canlı bahis heyecanı Bilyoner'de."
  },
  '/canli-iddaa/e-futbol': {
    title: 'E-Futbol Canlı İddaa Oyna - Bilyoner',
    description:
      'E-Futbol canlı iddaa maçlarını takip et, anlık skorlarla kuponunu oluştur! Değişen oranlarla E-Futbol canlı bahis heyecanı Bilyoner’de seni bekliyor.',
  },
  '/canli-iddaa/e-basketbol': {
    title: 'E-Basketbol Canlı İddaa Oyna - Bilyoner',
    description:
      'E-Basketbol canlı iddaa maçlarını takip et, anlık skorlarla kuponunu oluştur! Değişen oranlarla E-Basketbol canlı bahis heyecanı Bilyoner’de seni bekliyor.',
  },
  '/canli-iddaa/amerikan-futbol': {
    title: 'Amerikan Futbolu Canlı İddaa Oyna - Bilyoner',
    description:
      'Amerikan Futbol canlı iddaa maçlarını takip et, anlık skorlarla kuponunu oluştur! Değişen oranlarla Amerikan Futbol canlı bahis heyecanı Bilyoner’de seni bekliyor.',
  },
  '/canli-iddaa/basketbol': {
    title: 'Basketbol Canlı İddaa Oyna - Bilyoner',
    description:
      "Basketbol canlı iddaa karşılaşmalarını takip ederek şimdi oynanan maçlara kupon hazırlayın! Basketbol canlı bahis heyecanı Bilyoner'de sizi bekliyor.",
  },
  '/canli-iddaa/snooker': {
    title: 'Snooker Canlı İddaa Oyna - Bilyoner',
    description:
      'Snookerda canlı İddaa heyecanı Bilyoner ile sizinle. Snooker maçlarının canlı İddaa oranlarını ve canlı maç skorlarını buradan takip edebilirsiniz.',
  },
  '/canli-iddaa/masa-tenisi': {
    title: 'Masa Tenisi Canlı İddaa Oyna - Bilyoner',
    description:
      'Masa tenisinde canlı İddaa heyecanı Bilyoner ile sizinle. Masa tenisi maçlarının canlı İddaa oranlarını ve canlı maç skorlarını buradan takip edebilirsiniz.',
  },
  '/canli-iddaa/buz-hokeyi': {
    title: 'Buz Hokeyi Canlı İddaa Oyna - Bilyoner',
    description:
      'Buz hokeyinde canlı İddaa heyecanı Bilyoner ile sizinle. Maçların canlı İddaa oranlarını ve canlı maç skorlarını buradan takip edebilirsiniz.',
  },
  '/canli-iddaa/mma': {
    title: 'MMA Canlı İddaa Oyna | Bilyoner',
    description:
      'MMA canlı iddaa Bilyoner’de oynanır! Kazandıran tahminler, iddaa programı, maç sonuçları ve canlı maç yayını ile Bilyoner’de şans her an yanınızda.',
  },
  '/canli-iddaa/tenis': {
    title: 'Tenis Canlı İddaa Oyna - Bilyoner',
    description:
      "Tenis canlı bahis tahminleriniz ile kıyasıya rekabette kazanmaya hazır olun! Değişen oranlarıyla oynanan tenis canlı iddaa heyecanı Bilyoner'de sizi bekliyor.",
  },
  '/canli-iddaa/voleybol': {
    title: 'Voleybol Canlı İddaa Oyna - Bilyoner',
    description:
      "Voleybol canlı bahis heyecanını yaşamaya hazır mısınız? Anlık değişen oranlar içerisinde voleybol canlı iddaa keyfini Bilyoner'de yaşayın, kazanmaya başlayın!",
  },
  '/canli-iddaa/hentbol': {
    title: 'Hentbol Canlı İddaa Oyna - Bilyoner',
    description:
      'Hentbolda canlı İddaa heyecanı Bilyoner ile sizinle. Hentbol maçlarının canlı İddaa oranlarını ve canlı maç skorlarını buradan takip edebilirsiniz.',
  },
  '/canli-iddaa/yaklasan-maclar': {
    title: 'Canlı İddaa Yaklaşan Maçlar - Bilyoner',
    description:
      'Canlı İddaa’da yaklaşan maçlardan haberdar olmak ve kazandıran kupon tahminleri yapmak için Bilyoner’in Yaklaşan Maçlar sayfasını takip edebilirsiniz.',
  },
  '/canli-iddaa/counter-strike-global-offence': {
    title:
      'Counter Strike Global Offence Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Counter Strike Global Offence’de Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! Counter Strike Global Offence Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/league-of-legends': {
    title: 'League of Legends Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'League of Legends’da Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! League of Legends Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/dota-2': {
    title: 'Dota 2 Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'League of Legends’da Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! League of Legends Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/starcraft-2': {
    title: 'Starcraft 2 Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Starcraft 2’de Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! Starcraft 2 Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/hearthstone': {
    title: 'Hearthstone Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Hearthstone’da Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! Hearthstone Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/call-of-duty': {
    title: 'Call of Duty Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Call of Duty’de Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! Call of Duty Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-iddaa/overwatch': {
    title: 'Overwatch Canlı İddaa Programı | İddaa Oyna | Bilyoner',
    description:
      'Overwatch’da Canlı İddaa, Bahsin İlk Adresi Bilyoner’de! Overwatch Canlı İddaa Bülteni, Canlı Sonuçlar ve Görsel Anlatımlar ile Bilyoner’de Seni Bekliyor!',
  },
  '/canli-skor': {
    title: 'Canlı Skor, Canlı Maç Sonuçları ve İddaa Sonuçları - Bilyoner',
    description:
      'Biten iddaa sonuçları ve canlı maç sonuçları Bilyoner’de! Tüm futbol müsabakalarının iddaa sonuçlarına ve canlı skor bilgilerine erişmek için hemen tıklayın!',
  },
  '/canli-skor/basketbol-canli-skor': {
    title: 'Basketbol Canlı Skor, Canlı Maç Sonuçları - Bilyoner',
    description:
      'Basketbol biten ve canlı maç sonuçları Bilyoner’de! Tüm basketbol karşılaşmalarının canlı iddaa sonuçları ve canlı skor bilgilerine erişmek için hemen tıklayın!',
  },
  '/canli-skor/tenis-canli-skor': {
    title: 'Tenis Canlı Skor, Canlı Maç Sonuçları - Bilyoner',
    description:
      "Tenis canlı maç sonuçları Bilyoner’den takip edilir! Tenis canlı İddaa sonuçları & canlı skor ve tenis maç yayınları Bilyoner'de sizi bekliyor.",
  },
  '/canli-skor/takip-ettiklerim': {
    title: 'Takip Ettiklerim - Canlı Sonuçlar - Bilyoner',
    description:
      'Kupon yaptıktan sonra kuponunuzdaki maçları takibe almak ister misiniz? Takip Ettiklerim bölümünden yakın merceğe aldığınız maçları inceleyebilirsiniz.',
  },
  '/canli-skor/kuponumdakiler': {
    title: 'Kuponumdakiler - Canlı Sonuçlar - Bilyoner',
    description:
      'Kuponunuzdaki maçları, bahis oranlarını ve oynamış olduğunuz skor tahminlerini Kuponumdakiler sayfasından takip edebilirsiniz.',
  },
  '/kuponlarim': {
    title: 'Kuponlarım - Bilyoner',
    description:
      'En güncel bahis kuponlarınızı görüntülemek ve yaptığınız İddaa kuponlarını anbean takip etmek için Kuponlarım sayfasından yararlanabilirsiniz.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/kuponlarim/iddaa/devam-eden/iddaa': {
    title: 'Devam Eden İddaa Kuponlarım - Bilyoner',
    description:
      'İddaa’da devam eden güncel bahis kuponlarınızı görüntülemek ve anbean takip etmek için Devam Eden İddaa Kuponları sayfasından yararlanabilirsiniz.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/mac-karti': {
    title: 'Bilyoner.com | Maç Kartı',
  },
  '/lig-karti': {
    title: 'Bilyoner.com | Lig Kartı',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/iddaa/kupon': {
    title: 'İddaa Kuponlarım | Bilyoner',
    description:
      'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',
    meta: [
      {
        name: 'og:image',
        content:
          'https://www.bilyoner.com/public/favicons/social-share-logo.jpg',
      },
      {
        name: 'og:image:width',
        content: '90',
      },
      {
        name: 'og:image:height',
        content: '90',
      },
      {
        name: 'og:site_name',
        content: 'Bilyoner',
      },
      {
        name: 'og:title',
        content: 'Bilyoner | Kuponlarım',
      },
      {
        name: 'og:type',
        content: 'website',
      },
      {
        name: 'og:description',
        content:
          'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',
      },
      { name: 'robots', content: 'noindex' }
    ],
  },
  '/tribun/kupon': {
    title: 'Tribun | Bilyoner',
    description:
      'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',
    meta: [
      {
        name: 'og:image',
        content:
          'https://www.bilyoner.com/public/favicons/social-share-logo.jpg',
      },
      {
        name: 'og:image:width',
        content: '90',
      },
      {
        name: 'og:image:height',
        content: '90',
      },
      {
        name: 'og:site_name',
        content: 'Bilyoner',
      },
      {
        name: 'og:title',
        content: 'Bilyoner | Tribün',
      },
      {
        name: 'og:type',
        content: 'website',
      },
      {
        name: 'og:description',
        content:
          'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',
      },
    ],
  },
  '/tribun/lider-100': {
    title: 'Hazır Kuponlar | Lider 100 - Bilyoner',
    description:
      'Hazır kuponlar, banko kuponlar ile kazanmak artık daha kolay! Bilyoner Lider 100’de, deneyimli kullanıcıların hazırladığı kazandıran kuponları takip edin.',
  },
  '/tribun/uzay-kuponlari': {
    title: 'Kazanan & Kazandıran Uzay Kuponlar - Bilyoner',
    description:
      'En çok kazanan ve kazandıran kuponlar Bilyoner’de! En çok kazanan iddaa hazır kuponları, banko kuponları ve kazanan listesini incelemek için hemen tıklayın!',
  },
  '/tribun/arama': {
    title: 'Tribun | Bilyoner',
    description:
      'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',

    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
  '/tribun/profil': {
    title: 'Tribun | Bilyoner',
    description:
      'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!',

    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/uye-ol': {
    title: 'Üye Ol - Bilyoner',
    description:
      'Bilyoner üyeliğinizi oluşturun, İddaa ve bahis heyecanına siz de ortak olun. Kazandıran tahminler & canlı skorlar eşliğinde Bilyoner’de şans her an yanınızda!',
  },
  '/kampanyalar': {
    title: 'Kampanyalar - Bilyoner',
    description:
      'Bilyoner kampanyaları hakkında bilgi almak için hemen Bilyoner’e üye olun. Bilyoner ile şans her an yanınızda!',
  },
  '/canli-mac-izle': {
    title: 'Canlı Maç İzle - Canlı Maç Yayınları - Bilyoner',
    description:
      "Canlı maç izle, bahis yapma keyfini Bilyoner'le yaşa! Futbol, basketbol, voleybol ve tenis maçlarını ücretsiz olarak Bilyoner ile kesintisiz canlı izle!",
  },
  '/canli-mac-izle/canli-futbol-izle': {
    title: 'Canlı Futbol Maçı İzle - Canlı Futbol Maç Yayınları - Bilyoner',
    description:
      "Canlı futbol maçı izleme keyfi Bilyoner'de sizi bekliyor. Futbol maçlarını kesintisiz olarak canlı izlemek ve bahis keyfini yaşamak için hemen tıklayın!",
  },
  '/canli-mac-izle/canli-e-futbol-izle': {
    title: 'Canlı E-Futbol Maç Yayını İzle - Bilyoner',
    description:
      'Canlı E-Futbol izle, bahis heyecanını Bilyoner’le yaşa! En popüler E-Futbol maçlarını anlık skorlarla canlı takip etmek için hemen tıkla!',
  },
  '/canli-mac-izle/canli-e-basketbol-izle': {
    title: 'Canlı E-Basketbol Maç Yayını İzle - Bilyoner',
    description:
      'Canlı E-Basketbol izle, bahis heyecanını Bilyoner’le yaşa! En popüler E-Basketbol maçlarını anlık skorlarla canlı takip etmek için hemen tıkla!',
  },
  '/canli-mac-izle/canli-basketbol-izle': {
    title: 'Canlı Basketbol İzle & Canlı Basketbol Yayınları - Bilyoner',
    description:
      "Canlı basketbol izle, bahis yapma keyfini Bilyoner'le yaşa! Çin, Almanya, Euroleague, NBA basketbol maçlarını canlı izleme fırsatını kaçırmamak için tıkla!",
  },
  '/canli-mac-izle/canli-tenis-izle': {
    title: 'Canlı Tenis İzle & Canlı Yayın - Bilyoner',
    description:
      "Canlı tenis izle, bahis yapma keyfini Bilyoner'le yaşa! Tenis maçlarını kesintisiz olarak Bilyoner ile canlı izlemek ve takip etmek için hemen tıklayın!",
  },
  '/canli-mac-izle/canli-voleybol-izle': {
    title: 'Canlı Voleybol Maçı İzle - Canlı Voleybol Yayınları - Bilyoner',
    description:
      "Canlı voleybol maçı izle, bahis yapma keyfini Bilyoner'le yaşa! Voleybol maçlarını kesintisiz olarak Bilyoner ile canlı izlemek ve takip etmek için tıklayın!",
  },
  '/canli-mac-izle/canli-masa-tenisi-izle': {
    title: 'Canlı Masa Tenisi İzle',
    description:
      'Canlı masa tenis izle, bahis yapma keyfini Bilyoner\'le yaşa! Masa tenisi maçlarını kesintisiz olarak Bilyoner ile canlı izlemek ve takip etmek için hemen tıklayın!'
  },
  '/canli-mac-izle/canli-snooker-izle': {
    title: 'Canlı Snooker İzle',
    description:
      'Canlı snooker izle, bahis yapma keyfini Bilyoner\'le yaşa! Snooker maçlarını kesintisiz olarak Bilyoner ile canlı izlemek ve takip etmek için hemen tıklayın!'
  },
  '/canli-mac-izle/canli-buz-hokeyi-izle': {
    title: 'Canlı Buz Hokeyi İzle',
    description:
      'Canlı buz hokeyi izle, bahis yapma keyfini Bilyoner\'le yaşa! Dünyaca ünlü buz hokeyi maçlarını kesintisiz olarak Bilyoner ile canlı izlemek ve takip etmek için hemen tıklayın!'
  },
  '/bilgi-toplumu-hizmetleri': {
    title: 'Bilgi Toplumu Hizmetleri - Bilyoner',
    description:
      'Ticaret sicil numarası ve vergi dairesi başta olmak üzere tüm Bilyoner e-şirket bilgilerine buradan ulaşabilirsiniz.',
  },
  '/spor-toto': {
    title: 'Spor Toto Oyna - Bilyoner',
    description:
      'Spor Toto oynamak Bilyoner ile çok kolay! Kazandıran Spor Toto tahminleri, güncel Spor Toto listesi ve Spor Toto sonuçları Bilyoner’de sizi bekliyor.',
  },
  '/spor-toto/sonuclar': {
    title: 'Spor Toto Sonuçları - Bilyoner',
    description:
      'En güncel Spor Toto sonuçları Bilyoner’de! Spor Toto’da oynanan maçların sonuçları en güncel Spor Toto listesi eşliğinde Bilyoner’de sizi bekliyor.',
  },
  '/spor-toto/kuponlarim': {
    title: 'Spor Toto Kuponlarım - Bilyoner',
    description:
      'En güncel Spor Toto kuponlarınızı görüntülemek ve yaptığınız Spor Toto kuponlarını takip etmek için Spor Toto Kuponlarım sayfasından yararlanabilirsiniz.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/kullanim-sartlari': {
    title: 'Kullanım Şartları - Bilyoner',
    description:
      'Bilyoner kullanım şartlarını & koşullarını öğrenmek için Bilyoner Kullanım Şartları sayfasındaki bilgileri okuyabilirsiniz.',
  },
  '/kunye': {
    title: 'Bilyoner | Künye',
    description:
      'Türkiye’nin en güvenilir yasal bahis sitesi Bilyoner hakkında merak ettiğiniz soruların cevaplarını burada bulabilirsiniz.',
  },
  '/hakkimizda': {
    title: 'Bilyoner | Hakkımızda',
    description:
      'İddaa Bilyoner’de oynanır! Sporda eğlencenin adresi Bilyoner’de hemen iddaa oyna! Uzman yorumları, kazandıran iddaa tahminleri, canlı maç izle, hazır kuponlar, tribün ve spor toto Bilyoner’de!',
  },
  '/uyelik-sozlesmesi': {
    title: 'Üyelik Sözleşmesi - Bilyoner',
    description:
      'Bilyoner üyeliğine dair ayrıntılı bilgilere ve Bilyoner üyelik sözleşmesine bu sayfa üzerinden ulaşabilirsiniz.',
  },
  '/cerez-tercihleri-aydinlatma-metni': {
    title: 'KVKK - Bilyoner',
    description:
      'Kişisel veriler nasıl elde ediliyor? Kişisel verilerim neden kullanılıyor? Bilyoner KVKK ile ilgili merak ettiğiniz soruların yanıtları burada.',
  },
  '/yilin-enleri': {
    title: 'İddaa’da 2025 Yılının En’leri – Bilyoner',
    description:
      '2025 yılında en çok kazandıran bahisler, takımlar, ligler ve daha birçok istatistik Bilyoner’de. 2025 yılında yaşanan iddaa verilerine ulaşmak için hemen tıklayın!'
  },
  '/duyurular': {
    title: 'Duyurular - Bilyoner',
    description:
      'Bilyoner duyuru ve bilgilendirmelerini bu sayfa üzerinden takip edebilirsiniz.',
  },
  '/giris-yap': {
    title: 'Kullanıcı Girişi | Bilyoner',
    description: 'Kullanıcı girişi yapman için seni sayfamıza bekliyoruz.',
  },
  '/cikis-yap': {
    title: 'Kullanıcı Çıkış | Bilyoner',
    description: 'Kullanıcı girişi yapman için seni sayfamıza bekliyoruz.',
  },
  '/sifre-olustur': {
    title: 'Şifre Oluştur | Bilyoner',
    description: 'Yeni Bilyoner şifresi oluştur',
  },
  '/sifremi-unuttum': {
    title: 'Şifremi Unuttum - Bilyoner',
    description:
      'Bilyoner şifrenizi mi unuttunuz? Bilyoner Şifremi Unuttum sayfasını ziyaret ederek parolanızı sıfırlayabilir ve hesabınıza giriş yapabilirsiniz.',
  },
  '/milli-piyango': {
    title: 'Milli Piyango | Bilyoner',
    description:
      'Bilyoner güvencesiyle Milli Piyango bileti alın ve Sayısal Oyunlar (On Numara, Çılgın Sayısal Loto, Süper Loto, Şans Topu) oynayın, büyük ödülleri kazanın!.',
  },
  '/milli-piyango/biletlerim': {
    title: 'Milli Piyango Biletlerim | Bilyoner',
    description:
      'Milli piyango uzun vadeli biletlerin Bilyoner’de seni bekliyor! Milli piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/milli-mucadele-arac-cekilisi/satin-al/bilet': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
  },
  '/milli-mucadele-arac-cekilisi/satin-al/duz-seri-biletler/duz-beslik-seri': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
  },
  '/milli-mucadele-arac-cekilisi/satin-al/karisik-seri-biletler/karisik-beslik-seri': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
  },
  '/milli-mucadele-arac-cekilisi/biletlerim/devam-eden': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/milli-mucadele-arac-cekilisi/biletlerim/kazanan': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/milli-mucadele-arac-cekilisi/biletlerim/kaybeden': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/milli-mucadele-arac-cekilisi/ikramiye-listesi': {
    title: 'Bilyoner | Milli Dayanışma Kampanyası’na Destek Çekilişi',
    description:
      'Her Milli Piyango Biletiyle Biz Bize Yeteriz Türkiye’m Kampanyasına Destek Ol, Hem de Milli Dayanışma Çekilişine Katıl, BMW 320i Şansı Yakala!',
  },
  '/super-piyango/satin-al/super-bilet': {
    title: 'Süper Piyango Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango tam bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanınızda.',
  },
  '/super-piyango/satin-al/duz-seri-biletler/duz-beslik-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/satin-al/duz-seri-biletler/duz-onluk-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/satin-al/duz-seri-biletler/duz-yuzluk-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/satin-al/karisik-seri-biletler/karisik-beslik-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/satin-al/karisik-seri-biletler/karisik-onluk-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/satin-al/karisik-seri-biletler/karisik-yuzluk-seri': {
    title: 'Süper Piyango Seri Bilet Satın Al | Bilyoner',
    description:
      'Süper piyango seri bilet Bilyoner’den alınır! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
  },
  '/super-piyango/sorgula': {
    title: 'Süper Piyango Sorgula | Bilyoner',
    description:
      'Süper piyango sorgulamak Bilyoner ile çok kolay! Tarihlere göre sonuçlar, ikramiyeler ve tüm sorgulara ulaşman için seni Bilyoner’e bekliyoruz!',
  },
  '/super-piyango/sonuclar': {
    title: 'Süper Piyango Sonuçları | Bilyoner',
    description:
      'Süper piyango sonuçlarına ulaşmak ve süper piyango bilet sorgusu için Bilyoner yanında! İkramiyeler, kazanan numaralar ve daha fazlası Bilyoner’de!',
  },
  '/super-piyango/biletlerim/devam-eden': {
    title: 'Süper Piyango Devam Eden Biletlerim | Bilyoner',
    description:
      'Süper piyango biletlerin Bilyoner’de seni bekliyor! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/super-piyango/biletlerim/kazanan': {
    title: 'Süper Piyango Kazanan Biletlerim | Bilyoner',
    description:
      'Süper piyango biletlerin Bilyoner’de seni bekliyor! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/super-piyango/biletlerim/kaybeden': {
    title: 'Süper Piyango Kaybeden Biletlerim | Bilyoner',
    description:
      'Süper piyango biletlerin Bilyoner’de seni bekliyor! Süper piyango biletleri, geçmiş çekiliş sonuçları ile Bilyoner’de şans her an yanında.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/super-piyango/ikramiye-listesi': {
    title: 'Süper Piyango Sonuçları | İkramiye Listesi | Bilyoner',
    description:
      'Süper piyango sonuçları, ikramiye listesi Bilyoner’de seni bekliyor!',
  },
  '/yardim': {
    title: 'Yardım | Bilyoner',
    description:
      'İddaa, canlı iddaa, üyelik, spor toto, milli piyango, hizmetler ile ilgili yardım almak istediğiniz konuların cevaplarına yardım sayfamızdan ulaşabilirsiniz.',
  },
  '/yardim/bize-yazin': {
    title: 'Bize Yazın - Bilyoner',
    description:
      'Bilyoner, İddaa, bahis kuralları, İddaa terimleri ve merak ettiğiniz benzeri tüm sorularınız için bize yazabilirsiniz.',
  },
  '/yardim/yardim-konulari': {
    title: 'Bilyoner Yardım Konuları | Bilyoner',
    description:
      'İddaa, canlı iddaa, üyelik, spor toto, milli piyango, hizmetler ile ilgili yardım almak istediğiniz konuların cevaplarına yardım sayfamızdan ulaşabilirsiniz.',
  },
  '/yardim/yardim-konulari/spor-toto': {
    title: 'Spor Toto - Yardım - Bilyoner',
    description:
      'Spor Toto nasıl oynanır? Spor Toto oyun kuralları nedir? Spor Toto ile ilgili merak edilen sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/milli-piyango-hisseli-bilet': {
    title: 'Milli Piyango Hisseli Bilet - Yardım - Bilyoner',
    description:
      'Hisseli Bilet nedir? Hisseli Bilet paketi nasıl oluşturulur? Milli Piyango Hisseli Bilet hakkında merak edilen sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/ikramiyeler': {
    title: 'Milli Piyango İkramiyeleri - Yardım - Bilyoner',
    description:
      'Kazandığım ikramiyeyi nasıl alırım? İkramiyeden vergi kesintisi yapılıyor mu? Milli Piyango hakkında merak edilen tüm sorular & cevapları burada.',
  },
  '/yardim/yardim-konulari/para-cekme': {
    title: 'Para Çekme - Yardım - Bilyoner',
    description:
      'Hesabımdaki parayı nasıl çekebilirim? Başkasının hesabına para transferi yapabilir miyim? Bilyoner Para Çekme ile ilgili merak edilen sorular & cevapları burada.',
  },
  '/yardim/yardim-konulari/para-yatirma': {
    title: 'Para Yatırma - Yardım - Bilyoner',
    description:
      'Bilyoner hesabıma nasıl para yatırabilirim? EFT ile hesabıma nasıl para yatırırım? Bilyoner Para Yatırma ile ilgili merak edilen sorular & cevapları burada.',
  },
  '/yardim/yardim-konulari/iddaa': {
    title: 'İddaa & Canlı İddaa - Yardım - Bilyoner',
    description:
      'İddaa nedir? Canlı İddaa nedir? İddaa kuralları nedir? İddaa hakkında merak edilen sorular & cevapları burada.',
  },
  '/yardim/yardim-konulari/milli-piyango': {
    title: 'Milli Piyango - Yardım - Bilyoner',
    description:
      'Milli Piyango çekilişi ne zaman? Nasıl bilet alırım? Milli piyango hakkında merak edilen sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/super-piyango': {
    title: 'Süper Piyango - Yardım - Bilyoner',
    description:
      'Süper Piyango nasıl oynanır? Süper piyango ne zaman çekiliyor? Süper Piyango ile ilgili merak edilen sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/super-sayisal-oyunlar': {
    title: 'Süper Sayısal Oyunlar - Yardım - Bilyoner',
    description:
      'Süper Sayısal nasıl oynanır? Süper Sayısal hangi gün çekiliyor? Süper Sayısal Oyunlar ile ilgili merak edilen sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/milli-dayanismaya-destek-cekilis-bileti': {
    title: 'Milli Dayanışmaya Destek Çekiliş Bileti - Yardım - Bilyoner',
    description:
      'Milli Dayanışmaya Destek Çekiliş Bİleti hakkında merak edilen tüm sorular & cevapları Bilyoner’de.',
  },
  '/yardim/yardim-konulari/canli-yayin': {
    title: 'Canlı Maç Yayını - Yardım - Bilyoner',
    description:
      'Canlı maç yayını ücretli mi? Canlı maç yayınını hangi kanaldan izleyebilirim? Bilyoner canlı yayın hakkında merak edilen sorular & cevapları burada.',
  },
  '/yardim/yardim-konulari/tribun': {
    title: 'Tribün - Yardım - Bilyoner',
    description:
      'Kuponlarınızı paylaşabileceğiniz ve diğer üyelerin kuponlarını görebileceğiniz Bilyoner’in sosyal platformu Tribün hakkında merak ettikleriniz burada.',
  },
  '/yardim/yardim-konulari/uyelik': {
    title: 'Üyelik - Yardım - Bilyoner',
    description:
      'Bilyoner üyeliğine dair ayrıntılı bilgilere ve üyelik aşamaları ile ilgili merak ettiğiniz tüm soruların yanıtlarına bu sayfa üzerinden ulaşabilirsiniz.',
  },
  '/sanal-bahis': {
    title: 'Sanal Bahis Oyna | Bilyoner',
    description: "Sanal Bahis Bilyoner'de Oynanır! Sporda Eğlencenin Adresi Bilyoner'de Serber Vuruş Sanal Bahislerine Oyna, Kazancın Anında Hesabında!",
  },
  '/sanal-bahis/serbest-vurus-pro-turkiye': {
    title: 'Sanal Bahis | Serbest Vuruş Pro Türkiye | Bilyoner',
    description: "Sanal Bahis Bilyoner'de Oynanır! Sporda Eğlencenin Adresi Bilyoner'de Hemen Serbest Vuruş Pro Türkiye Sanal Bahis Oyna, Pro Türkiye Sanal Bahis Heyecanı Bilyonerde! Sanal Bahis Oyna, Kazancın Anında Hesabında!",
  },
  '/sanal-bahis/serbest-vurus-pro-lig-turkiye': {
    title: 'Sanal Bahis | Serbest Vuruş Pro Lig Türkiye | Bilyoner',
    description: "Sanal Bahis Bilyoner'de Oynanır! Sporda Eğlencenin Adresi Bilyoner'de Hemen Serbest Vuruş Pro Lig Türkiye Sanal Bahis Oyna, Pro Lig Türkiye Sanal Bahis Heyecanı Bilyonerde! Kazancın Anında Hesabında!",
  },
  '/sanal-bahis/serbest-vurus-pro-italya': {
    title: 'Sanal Bahis | Serbest Vuruş Pro Italya | Bilyoner',
    description: "Sanal Bahis Bilyoner'de Oynanır! Sporda Eğlencenin Adresi Bilyoner'de Hemen Serbest Vuruş Pro İtalya Sanal Bahis Oyna, İtalya Sanal Bahis Heyecanı Bilyoner'de! Kazancın Anında Hesabında!",
  },
  '/sanal-bahis/serbest-vurus-pro-lig-italya': {
    title: 'Sanal Bahis | Serbest Vuruş Pro Lig Italya | Bilyoner',
    description: "Sanal Bahis Bilyoner'de Oynanır! Sporda Eğlencenin Adresi Bilyoner'de Hemen Serbest Vuruş Pro Lig İtalya Bahis Oyna, İtalya Sanal Bahis Heyecanı Bilyoner'de! Kazancın Anında Hesabında!",
  },
  '/sans-oyunlari': {
    title: 'Şans Oyunları | Şans Oyunu Oyna |  Bilyoner',
    description: "Şans oyunları tüm heyecanıyla Bilyoner'de! Tüm dijital şans oyunlarını görmek, Bilyoner ile eğlenirken kazanmak için hemen tıklayın!",
  },
  '/sans-oyunlari/hizli-tombala': {
    title: 'Hızlı Tombala Oyna | Hızlı Tombala Şans Oyunu |  Bilyoner',
    description: "Hızlı Tombala oyunu artık Bilyoner'de! Hızlı Tombala oyunu oynayarak eğlenerek kazanın! Hızlı Tombala heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/super-tombala': {
    title: 'Tombala Oyna | Tombala Şans Oyunu |  Bilyoner',
    description: "Dijital Tombala oyunu artık Bilyoner'de! Tombala oyunu oynayarak eğlenerek kazanın! Tombala heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/zeplin': {
    title: 'Zeplin Şans Oyunu Oyna - Bilyoner',
    description: "Zeplin Şans Oyunu Bilyoner'de oynanır! Zeplin oynayın, eğlenerek kazanın! Dijitalde Zeplin heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/plinko': {
    title: 'Plinko Şans Oyunu Oyna - Bilyoner',
    description: "Plinko şans oyunu Bilyoner'de! Plinko oyunu oynayarak hem eğlenin hem kazanın! Plinko'nun heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/mayin-tarlasi': {
    title: 'Mayın Tarlası Oyna - Bilyoner',
    description: "Mayın tarlası şans oyunu artık Bilyoner'de! Mayın tarlası oynayarak hem eğlenin hem kazanın! Mayın tarlası heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/asagi-yukari': {
    title: 'Aşağı Yukarı Oyna - Bilyoner',
    description: "Aşağı Yukarı şans oyunu artık Bilyoner'de! Aşağı Yukarı oynayarak hem eğlenin hem kazanın! Aşağı Yukarı heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/super-penalti': {
    title: 'Süper Penaltı Oyna - Bilyoner',
    description: "Süper Penaltı şans oyunu artık Bilyoner'de! Süper Penaltı oynayarak hem eğlenin hem kazanın! Süper Penaltı heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/super-onlu': {
    title: 'Süper 10’lu Oyna - Bilyoner',
    description: "Süper 10’lu şans oyunu artık Bilyoner'de! Süper 10’lu oynayarak hem eğlenin hem kazanın! Süper 10’lu heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/sansli-alti': {
    title: 'Şanslı 6 Oyna - Bilyoner',
    description: "Şanslı 6 şans oyunu artık Bilyoner'de! Şanslı 6 oynayarak hem eğlenin hem kazanın! Şanslı 6 heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/super-carkifelek': {
    title: 'Süper Çarkıfelek - Bilyoner',
    description: "Süper Çarkıfelek şans oyunu artık Bilyoner'de! Süper Çarkıfelek oynayarak hem eğlenin hem kazanın! Süper Çarkıfelek heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/super-tas-kagit-makas': {
    title: 'Süper Taş Kağıt Makas Oyunu',
    description: 'Süper Taş Kağıt Makas oyunu ile eğlenirken kazanmaya hazır olun! Taş Kağıt Makas online oyun deneyimi Bilyoner’de!',
  },
  '/sans-oyunlari/cilgin-ninja': {
    title: 'Çılgın Ninja Oyna | Ninja Crash Oyna | Bilyoner',
    description: "Çılgın Ninja oyunu Bilyoner'de! Çılgın Ninja (Ninja Crash) oynayarak hem eğlenin hem kazanın! Çılgın Ninja şans oyunu heyecanını Bilyoner ile yakalamak için hemen tıklayın!",
  },
  '/sans-oyunlari/muhtesem-atlantis': {
    title: 'Suda Halka Geçirme Oyunu: Muhteşem Atlantis - Bilyoner',
    description: "Suyun içindeki halkaları çubuklardan geçir, Atlantis'in hazinesinden sana düşeni kap! Online şans oyunu Atlantis ile Bilyoner'de şans oyunu heyecanını artır!",
  },
  '/sans-oyunlari/yazi-tura-at': {
    title: 'Online Yazı Tura At Bilyoner\'de Kazan',
    description: "Yüzde elli kazanma şansın var! Online yazı tura atarak online şans oyunu heyecanını Bilyoner'de yaşayabilirsin. Hemen yazı tura oyna!",
  },
  '/sans-oyunlari/kazanc-kulesi': {
    title: 'Kazanç Kulesinde Blokları Yerleştir Bahsini Yükselt - Bilyoner',
    description: "Kazancını yükseltmek için blokları yükseltmeye başla. Blok oyunu Kazanç kulesi ile online şans oyunu deneyimini Bilyoner'de yaşa!",
  },
  '/sans-oyunlari/altin-cark': {
    title: 'Altın Çark Oyna | Altın Çark Bilyoner',
    description: "Kazancını yükseltmek için blokları yükseltmeye başla. Blok oyunu Kazanç kulesi ile online şans oyunu deneyimini Bilyoner'de yaşa!",
  },
  '/sans-oyunlari/kazandiran-balonlar': {
    title: 'Kazandıran Balonlar Oyna | Kazandıran Balonlar Bilyoner',
    description: "Kazancını yükseltmek için blokları yükseltmeye başla. Blok oyunu Kazanç kulesi ile online şans oyunu deneyimini Bilyoner'de yaşa!",
  },
  '/sans-oyunlari/sansli-eslesme': {
    title: 'Şanslı Eşleşme Oyna | Şanslı Eşleşme Bilyoner',
    description: 'Sürükleyici kutu açma heyecanıyla Şanslı Eşleşme’de aynı sembolleri yakala, anında ödülleri kap! Eğlenceli, hızlı ve bol kazançlı bu şans oyunu seni bekliyor.',
  },
  '/sans-oyunlari/mega-balon': {
    title: 'Mega Baloon Oyna | Mega Baloon Bilyoner',
    description: 'Mega Baloon ile heyecan dolu anlar yaşayın. Şimdi Bilyoner’de online olarak oynayın, kazanma şansını yakalayın!',
  },
  '/sans-oyunlari/buyulu-kapadokya': {
    title: 'Büyülü Kapadokya Oyna | Büyülü Kapadokya Bilyoner',
    description: 'Büyülü Kapadokya ile oyun keyfini zirveye taşıyın. Bilyoner\'de hemen deneyin!',
  },
  '/kazi-kazan': {
    title: 'Online Kazı Kazan | Bilyoner',
    description: 'Bilyoner Kazı Kazan ile anında kazanmanın keyfini yaşayın! Milli Piyango güvencesiyle Kazı Kazan oyunlarını hemen keşfedin!',
  },
  '/sanal-yaris': {
    title: 'Sanal Yarış | Bilyoner',
    description: 'Gerçek Görüntülü At Yarışı, Sanal At Yarışı, Gerçek Görüntülü ve Sanal Tazı Yarışı oyunlarıyla 7/24 kesintisiz yarış heyecanı burada.',
  },
  '/bas-kazan': {
    title: 'BasKazan | Bilyoner',
    description: 'Bilyoner BasKazan ile anında kazanmanın keyfini yaşayın! Milli Piyango güvencesiyle Bas Kazan oyunlarını hemen keşfedin!',
  },
  '/euro2024': {
    title: 'EURO 2024 Avrupa Futbol Şampiyonası',
    description: 'EURO 2024 puan durumu, fikstür Bilyoner’de! Avrupa Futbol Şampiyonası sahnesinde kıran kırana geçen mücadeleyi yakından takip etmek için tıklayın!',
  },
  '/indir': {
    title: 'Mobil Uygulama İndir - Bilyoner',
    description:
      "Bilyoner mobil uygulaması ile bahis dünyası cebinizde. Siz de Bilyoner uygulamasını indirin, hemen kuponunuzu oluşturun, Canlı İddaa'nın keyfine varın!",
  },
  '/e-posta-abonelik': {
    title: 'E-posta Abonelik | Bilyoner',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/ara-verme': {
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/iptal': {
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  '/sans-oyunlari/esya-piyangosu': {
    title: 'Eşya Piyangosu Çekilişi | Milli Piyango Eşya Piyangosu - Bilyoner',
    description: 'Milli piyango eşya piyangosu Bilyoner’de oynanır! Eşya piyangosu çekilişine katılarak birbirinden özel ödülleri kazanmaya başlamak için hemen tıklayın!',
  },
  '/sans-oyunlari/esya-piyangosu/biletlerim': {
    title: 'Eşya Piyangosu Biletlerim - Bilyoner',
    description: 'Eşya piyangosu için satın aldığınız çekiliş biletlerinizi ve çekiliş haklarınızı görüntülemek için hemen tıklayın!',
  },
  '/sans-oyunlari/esya-piyangosu/cekilis-sonuclari': {
    title: 'Eşya Piyangosu Çekiliş Sonuçları | Kazananlar Listesi - Bilyoner',
    description: 'Eşya piyangosu çekiliş sonuçları için hemen tıklayın! Milli piyango eşya piyangosu Bilyoner’de oynanır.',
  },
  '/sans-oyunlari/esya-piyangosu/bilet-detay': {
    title: 'Biletlerim Detay - Bilyoner',
    description: 'Satın aldığınız eşya piyangosu çekilişi biletlerinize ikramiyenin isabet edip etmediğini görmek için hemen tıklayın!',
  },
  '/sans-oyunlari/esya-piyangosu/iletisim-izinleri': {
    title: 'Eşya Piyangosu İletişim İzinleri - Bilyoner',
    description: 'Kampanyalardan ve gelecek çekilişlerden haberdar olmak için iletişim izinlerini Bilyoner iletişim izinleri sayfasından aktif edebilirsiniz.',
  },
  '/sans-oyunlari/oyna-kazan': {
    title: 'Oyna Kazan Oyna - Bilyoner',
    description: 'Oyna Kazan Bilyoner’de oynanır! Oyna Kazan ile şimdi kazı kazan, BilyonPuanları topla. Oyna Kazan heyecanını Bilyoner ile yakalamak için hemen kazı kazan!',
  },
  '/sans-oyunlari/oyna-kazan/kart': {
    title: 'Kart Kazı | Oyna Kazan - Bilyoner',
    description: 'Oyna Kazan oyununda seçtiğiniz kartları kazıyarak hem eğlenin hem kazanın. Oyna Kazan heyecanı Bilyoner ile yaşanır!',
  },
  '/sans-oyunlari/oyna-kazan/kartlarim': {
    title: 'Kartlarım | Oyna Kazan - Bilyoner',
    description: 'Kartlarım sayfası sayesinde kazandığınız veya kaybettiğiniz kartların detaylarına ulaşabilirsiniz. Detaylı bilgiye ulaşmak için tıklayın.',
  },
  '/sans-oyunlari/oyna-kazan/kartlarim/kazanan': {
    title: 'Kazanan Kartlar | Oyna Kazan - Bilyoner',
    description: 'Oyna Kazan oyununda oynadığınız ve kazandığınız kartları incelemek, detaylı bilgi almak ve görüntülemek için tıklayın!',
  },
  '/sans-oyunlari/oyna-kazan/kartlarim/kaybeden': {
    title: 'Kaybeden Kartlar | Oyna Kazan - Bilyoner',
    description: 'Oyna Kazan oyununda oynadığınız ve kaybettiğiniz kartları incelemek, detaylı bilgi almak ve görüntülemek için tıklayın!',
  },
  '/sans-oyunlari/oyna-kazan/kurallar': {
    title: 'Oyna Kazan Oyunun Kuralları - Bilyoner',
    description: 'Oyna Kazan oyunun kurallarını, nasıl oynandığını ve oyunlarla ilgili detaylı bilgilere ulaşmak için hemen tıklayın! Bilyoner ile Oyna Kazan oyununa heyecanına ortak olun.',
  },
  '/tribun/takip-ettiklerim': {
    title: 'Takip Ettiklerim - Bilyoner',
    description: 'Takip Ettiklerim sayfası, Bilyoner.com’da bahis yaparken takip ettiğin kullanıcıların kuponlarını tek bir yerde toplar.',
  },
  '/tribun/tum-uyeler': {
    title: 'Tüm Üyeler - Bilyoner',
    description: 'Bilyoner.com’da tüm üyelerimizin listelendiği sayfayı keşfet! Burada, bahis dünyasının en heyecan verici kullanıcılarına ulaşabilirsin.',
  },
  '/tribun/kazananlar': {
    title: 'En Çok Kazanan & Kazandıran Kuponlar - Bilyoner',
    description: 'En çok kazanan ve kazandıran kuponlar Bilyoner’de! En çok kazanan hazır iddaa kuponlarını, banko kuponları ve kazanan listesini incelemek için hemen tıkla!',
  },
  '/tribun/tribun-liderleri': {
    title: 'İddaa En Çok Kazandıran & En İyi Tahminciler - Bilyoner',
    description: 'Bilyoner’de en kazandıran, en iyi tahmin yapan üyeleri takip et! En başarılı iddaa kuponlarına imza atan üyelerimizi takip ederek kazanma şansını yakala!',
  },
  '/arkadasini-getir': {
    title: 'Arkadaşını Getir Kampanyası Şu Anda Aktif Değildir!',
    description:
      'Bu kampanyadan 30.12.2025 tarihi itibarıyla yararlanılamamaktadır.',
  },
  '/coklu-mac-takibi': {
    title: 'Çoklu Maç Takibi: 3 Farklı Maçı Canlı Takip Et',
    description:
      'Çoklu maç takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı maçın canlı skorları, istatistikleri ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/futbol': {
    title: 'Çoklu Maç Takibi - Futbol',
    description:
      'Çoklu futbol maçı takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı maçın canlı skorları, istatistikleri ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/basketbol': {
    title: 'Çoklu Maç Takibi - Basketbol',
    description:
      'Çoklu basketbol maçı takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı basketbol maçının canlı skorları ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/tenis': {
    title: 'Çoklu Maç Takibi - Tenis',
    description:
      'Çoklu tenis maçı takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı tenis maçının canlı skorları ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/buz-hokeyi': {
    title: 'Çoklu Maç Takibi - Buz Hokeyi',
    description:
      'Çoklu buz hokeyi maçı takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı buz hokeyi maçının canlı skorları ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/voleybol': {
    title: 'Çoklu Maç Takibi - Voleybol',
    description:
      'Çoklu voleybol maçı takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3 farklı voleybol maçının canlı skorları ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/coklu-mac-takibi/motor-sporlari': {
    title: 'Çoklu Maç Takibi - Motor Sporları',
    description:
      'Çoklu motor sporu takibi yapmanın en kolay yolu Bilyoner\'de! Aynı sayfada 3-4 farklı motor sporu maçının canlı skorları ve daha fazlasını anlık olarak görüntüleyin.',
  },
  '/lig-merkezi': {
    title: 'Lig Merkezi - Bilyoner',
    description: 'Süper Lig’den 1. Lig’e futbol dünyasına dair aradığınız tüm bilgiler Bilyoner Lig Merkezi’nde! Süper Lig puan durumu ve daha fazla bilgi için hemen tıklayın!'
  },
  '/lig-merkezi/canli-yayin-rehberi': {
    title: 'Canlı Yayın Rehberi',
    description: 'Canlı Yayın Rehberi ile Bilyoner’de hangi maçların canlı yayınlandığını kolayca öğrenin. Güncel canlı yayın programı için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-avrupa-ligi/fikstur': {
    title: 'UEFA Avrupa Ligi Fikstür - Bilyoner',
    description: 'UEFA Avrupa Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. UEFA Avrupa Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/euroleague/fikstur': {
    title: 'EuroLeague Fikstür - Bilyoner',
    description: 'EuroLeague fikstür bilgileri Bilyoner dünyasında sizi bekliyor. EuroLeague maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-kupasi/puan-durumu': {
    title: 'Türkiye Kupası Puan Durumu - Bilyoner',
    description: 'Türkiye Kupası puan durumu bilgileri Bilyoner’de! Türkiye Kupası puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/euroleague/sayi-kralligi': {
    title: 'EuroLeague Sayı Krallığı - Bilyoner',
    description: 'EuroLeague sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/eurobasket/puan-durumu': {
    title: 'EuroBasket Puan Durumu - Bilyoner',
    description: 'EuroBasket puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!'
  },
  '/lig-merkezi/eurobasket/fikstur': {
    title: 'EuroBasket Fikstür - Bilyoner',
    description: 'EuroBasket fikstür bilgileri Bilyoner dünyasında sizi bekliyor. EuroBasket maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/eurobasket/sayi-kralligi': {
    title: 'EuroBasket Sayı Krallığı - Bilyoner',
    description: 'EuroBasket sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/eurobasket/asist-kralligi': {
    title: 'EuroBasket Asist Krallığı - Bilyoner',
    description: 'EuroBasket asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/eurobasket/ribaund-kralligi': {
    title: 'EuroBasket Ribaund Krallığı - Bilyoner',
    description: 'EuroBasket ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyunculrın sıralamasını görmek için hemen tıklayın.'
  },


  '/lig-merkezi/eurocup/asist-kralligi': {
    title: 'EuroCup Asist Krallığı - Bilyoner',
    description: 'EuroCup asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/caykur-rizespor/kadro': {
    title: 'Çaykur Rizespor Kadro - Bilyoner',
    description: 'Çaykur Rizespor kadro bilgileri Bilyoner’de buluşuyor. Çaykur Rizespor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/kasimpasa/fikstur': {
    title: 'Kasımpaşa Fikstür - Bilyoner',
    description: 'Kasımpaşa fikstür bilgileri futbolun tek adresi Bilyoner’de! Kasımpaşa maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/euroleague/ribaund-kralligi': {
    title: 'EuroLeague ribaund Krallığı - Bilyoner',
    description: 'EuroLeague ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyunculrın sıralamasını görmek için hemen tıklayın.'
  },
  '/lig-merkezi/kasimpasa/puan-durumu': {
    title: 'Kasımpaşa Puan Durumu - Bilyoner',
    description: 'Kasımpaşa puan durumu tüm detaylarıyla Bilyoner’de! Kasımpaşa Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/trabzonspor/puan-durumu': {
    title: 'Trabzonspor Puan Durumu - Bilyoner',
    description: 'Trabzonspor puan durumu tüm detaylarıyla Bilyoner’de! Trabzonspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/alanyaspor/puan-durumu': {
    title: 'Alanyaspor Puan Durumu - Bilyoner',
    description: 'Alanyaspor puan durumu tüm detaylarıyla Bilyoner’de! Alanyaspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/tff-2-lig/gol-kralligi': {
    title: 'TFF 2. Lig Gol Krallığı - Bilyoner',
    description: 'TFF 2. Lig gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. TFF 2. Lig oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/caykur-rizespor/fikstur': {
    title: 'Çaykur Rizespor Fikstür - Bilyoner',
    description: 'Çaykur Rizespor fikstür bilgileri futbolun tek adresi Bilyoner’de! Çaykur Rizespor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/hollanda-eredivisie-ligi/sari-kirmizi-kartlar': {
    title: 'Hollanda Eredivisie Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Hollanda Eredivisie Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Hollanda Eredivisie Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/italya-seria/puan-durumu': {
    title: 'İtalya Serie A Puan Durumu - Bilyoner',
    description: 'İtalya Serie A puan durumu bilgileri Bilyoner’de! İtalya Serie A puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/sampiyonlar-ligi/asist-kralligi': {
    title: 'Şampiyonlar Ligi Asist Krallığı - Bilyoner',
    description: 'Şampiyonlar Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! Şampiyonlar Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/antalyaspor/istatistikler': {
    title: 'Antalyaspor İstatistikler - Bilyoner',
    description: 'Antalyaspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Antalyaspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-avrupa-ligi/puan-durumu': {
    title: 'UEFA Avrupa Ligi Puan Durumu - Bilyoner',
    description: 'UEFA Avrupa Ligi puan durumu bilgileri Bilyoner’de! UEFA Avrupa Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/istanbul-basaksehir/istatistikler': {
    title: 'İstanbul Başakşehir İstatistikler - Bilyoner',
    description: 'İstanbul Başakşehir istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! İstanbul Başakşehir maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/tff-1-lig/sari-kirmizi-kartlar': {
    title: 'TFF 1. Lig Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'TFF 1. Lig oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. TFF 1. Lig sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/fenerbahce/kadro': {
    title: 'Fenerbahçe Kadro - Bilyoner',
    description: 'Fenerbahçe kadro bilgileri Bilyoner’de buluşuyor. Fenerbahçe maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/galatasaray/puan-durumu': {
    title: 'Galatasaray Puan Durumu - Bilyoner',
    description: 'Galatasaray puan durumu tüm detaylarıyla Bilyoner’de! Galatasaray Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/almanya-bundesliga/fikstur': {
    title: 'Almanya Bundesliga Fikstür - Bilyoner',
    description: 'Almanya Bundesliga fikstür bilgileri futbolun tek adresi Bilyoner’de. Almanya Bundesliga maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fenerbahce/puan-durumu': {
    title: 'Fenerbahçe Puan Durumu - Bilyoner',
    description: 'Fenerbahçe puan durumu tüm detaylarıyla Bilyoner’de! Fenerbahçe Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/italya-seria/fikstur': {
    title: 'İtalya Serie A Fikstür - Bilyoner',
    description: 'İtalya Serie A fikstür bilgileri futbolun tek adresi Bilyoner’de. İtalya Serie A maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fiba-sampiyonlar-ligi/ribaund-kralligi': {
    title: 'FIBA Şampiyonlar Ligi ribaund Krallığı - Bilyoner',
    description: 'FIBA Şampiyonlar Ligi ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyunculrın sıralamasını görmek için hemen tıklayın.'
  },
  '/lig-merkezi/ingiltere-premier-lig/fikstur': {
    title: 'İngiltere Premier Ligi Fikstür - Bilyoner',
    description: 'İngiltere Premier Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. İngiltere Premier Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/euroleague/asist-kralligi': {
    title: 'EuroLeague Asist Krallığı - Bilyoner',
    description: 'EuroLeague asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/goztepe/fikstur': {
    title: 'Göztepe Fikstür - Bilyoner',
    description: 'Göztepe fikstür bilgileri futbolun tek adresi Bilyoner’de! Göztepe maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/fiba-sampiyonlar-ligi/sayi-kralligi': {
    title: 'FIBA Şampiyonlar Ligi Sayı Krallığı - Bilyoner',
    description: 'FIBA Şampiyonlar Ligi sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/kasimpasa/kadro': {
    title: 'Kasımpaşa Kadro - Bilyoner',
    description: 'Kasımpaşa kadro bilgileri Bilyoner’de buluşuyor. Kasımpaşa maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/eurocup/fikstur': {
    title: 'EuroCup Fikstür - Bilyoner',
    description: 'EuroCup fikstür bilgileri Bilyoner dünyasında sizi bekliyor. EuroCup maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-uluslar-ligi/puan-durumu': {
    title: 'UEFA Uluslar Ligi Puan Durumu - Bilyoner',
    description: 'UEFA Uluslar Ligi puan durumu bilgileri Bilyoner’de! UEFA Uluslar Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/turkiye-kupasi/sari-kirmizi-kartlar': {
    title: 'Türkiye Kupası Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Türkiye Kupası oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Türkiye Kupası sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/uefa-konferans-ligi/fikstur': {
    title: 'UEFA Konferans Ligi Fikstür - Bilyoner',
    description: 'UEFA Konferans Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. UEFA Konferans Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/antalyaspor/puan-durumu': {
    title: 'Antalyaspor Puan Durumu - Bilyoner',
    description: 'Antalyaspor puan durumu tüm detaylarıyla Bilyoner’de! Antalyaspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/konyaspor/kadro': {
    title: 'Konyaspor Kadro - Bilyoner',
    description: 'Konyaspor kadro bilgileri Bilyoner’de buluşuyor. Konyaspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fransa-league-1/gol-kralligi': {
    title: 'Fransa Ligue 1 Gol Krallığı - Bilyoner',
    description: 'Fransa Ligue 1 gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Fransa Ligue 1 oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/hollanda-eredivisie-ligi/fikstur': {
    title: 'Hollanda Eredivisie Ligi Fikstür - Bilyoner',
    description: 'Hollanda Eredivisie Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. Hollanda Eredivisie Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/istanbul-basaksehir/puan-durumu': {
    title: 'İstanbul Başakşehir Puan Durumu - Bilyoner',
    description: 'İstanbul Başakşehir puan durumu tüm detaylarıyla Bilyoner’de! İstanbul Başakşehir Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/fransa-league-1/puan-durumu': {
    title: 'Fransa Ligue 1 Puan Durumu - Bilyoner',
    description: 'Fransa Ligue 1 puan durumu bilgileri Bilyoner’de! Fransa Ligue 1 puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/ingiltere-premier-lig/sari-kirmizi-kartlar': {
    title: 'İngiltere Premier Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'İngiltere Premier Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. İngiltere Premier Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/turkiye-super-ligi/puan-durumu': {
    title: 'Türkiye Süper Ligi Puan Durumu - Bilyoner',
    description: 'Türkiye Süper Ligi puan durumu bilgileri Bilyoner’de! Türkiye Süper Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/fiba-sampiyonlar-ligi/fikstur': {
    title: 'FIBA Şampiyonlar Ligi Fikstür - Bilyoner',
    description: 'FIBA Şampiyonlar Ligi fikstür bilgileri Bilyoner dünyasında sizi bekliyor. FIBA Şampiyonlar Ligi maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-kupasi/asist-kralligi': {
    title: 'Türkiye Kupası Asist Krallığı - Bilyoner',
    description: 'Türkiye Kupası asist krallığı futbol dünyasının tek adresi Bilyoner’de! Türkiye Kupası maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/trabzonspor/kadro': {
    title: 'Trabzonspor Kadro - Bilyoner',
    description: 'Trabzonspor kadro bilgileri Bilyoner’de buluşuyor. Trabzonspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/sampiyonlar-ligi/sari-kirmizi-kartlar': {
    title: 'Şampiyonlar Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Şampiyonlar Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Şampiyonlar Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/kayserispor/istatistikler': {
    title: 'Kayserispor İstatistikler - Bilyoner',
    description: 'Kayserispor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Kayserispor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-avrupa-ligi/asist-kralligi': {
    title: 'UEFA Avrupa Ligi Asist Krallığı - Bilyoner',
    description: 'UEFA Avrupa Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! UEFA Avrupa Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/samsunspor/kadro': {
    title: 'Samsunspor Kadro - Bilyoner',
    description: 'Samsunspor kadro bilgileri Bilyoner’de buluşuyor. Samsunspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-basketbol-super-ligi/fikstur': {
    title: 'Türkiye Basketbol Süper Ligi Fikstür - Bilyoner',
    description: 'Türkiye Basketbol Süper Ligi fikstür bilgileri Bilyoner dünyasında sizi bekliyor. Türkiye Basketbol Süper Ligi maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/nba/puan-durumu': {
    title: 'NBA Puan Durumu - Bilyoner',
    description: 'NBA puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!'
  },
  '/lig-merkezi/gaziantep-fk/puan-durumu': {
    title: 'Gaziantep FK Puan Durumu - Bilyoner',
    description: 'Gaziantep FK puan durumu tüm detaylarıyla Bilyoner’de! Gaziantep FK Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/eyupspor/puan-durumu': {
    title: 'Eyüpspor Puan Durumu - Bilyoner',
    description: 'Eyüpspor puan durumu tüm detaylarıyla Bilyoner’de! Eyüpspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/gaziantep-fk/istatistikler': {
    title: 'Gaziantep FK İstatistikler - Bilyoner',
    description: 'Gaziantep FK istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Gaziantep FK maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/ingiltere-premier-lig/asist-kralligi': {
    title: 'İngiltere Premier Ligi Asist Krallığı - Bilyoner',
    description: 'İngiltere Premier Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! İngiltere Premier Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/karagumruk/istatistikler': {
    title: 'Karagümrük İstatistikler - Bilyoner',
    description: 'Karagümrük istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Karagümrük maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-avrupa-ligi/sari-kirmizi-kartlar': {
    title: 'UEFA Avrupa Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'UEFA Avrupa Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. UEFA Avrupa Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/almanya-bundesliga/gol-kralligi': {
    title: 'Almanya Bundesliga Gol Krallığı - Bilyoner',
    description: 'Almanya Bundesliga gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Almanya Bundesliga oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/alanyaspor/kadro': {
    title: 'Alanyaspor Kadro - Bilyoner',
    description: 'Alanyaspor kadro bilgileri Bilyoner’de buluşuyor. Alanyaspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/nba/ribaund-kralligi': {
    title: 'NBA ribaund Krallığı - Bilyoner',
    description: 'NBA ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyunculrın sıralamasını görmek için hemen tıklayın.'
  },
  '/lig-merkezi/goztepe/puan-durumu': {
    title: 'Göztepe Puan Durumu - Bilyoner',
    description: 'Göztepe puan durumu tüm detaylarıyla Bilyoner’de! Göztepe Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/kocaelispor/kadro': {
    title: 'Kocaelispor Kadro - Bilyoner',
    description: 'Kocaelispor kadro bilgileri Bilyoner’de buluşuyor. Kocaelispor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/italya-seria/asist-kralligi': {
    title: 'İtalya Serie A Asist Krallığı - Bilyoner',
    description: 'İtalya Serie A asist krallığı futbol dünyasının tek adresi Bilyoner’de! İtalya Serie A maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/konyaspor/puan-durumu': {
    title: 'Konyaspor Puan Durumu - Bilyoner',
    description: 'Konyaspor puan durumu tüm detaylarıyla Bilyoner’de! Konyaspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/ispanya-la-liga/asist-kralligi': {
    title: 'İspanya La Liga Asist Krallığı - Bilyoner',
    description: 'İspanya La Liga asist krallığı futbol dünyasının tek adresi Bilyoner’de! İspanya La Liga maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/galatasaray/fikstur': {
    title: 'Galatasaray Fikstür - Bilyoner',
    description: 'Galatasaray fikstür bilgileri futbolun tek adresi Bilyoner’de! Galatasaray maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/kocaelispor/puan-durumu': {
    title: 'Kocaelispor Puan Durumu - Bilyoner',
    description: 'Kocaelispor puan durumu tüm detaylarıyla Bilyoner’de! Kocaelispor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/uefa-konferans-ligi/asist-kralligi': {
    title: 'UEFA Konferans Ligi Asist Krallığı - Bilyoner',
    description: 'UEFA Konferans Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! UEFA Konferans Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/hollanda-eredivisie-ligi/gol-kralligi': {
    title: 'Hollanda Eredivisie Ligi Gol Krallığı - Bilyoner',
    description: 'Hollanda Eredivisie Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Hollanda Eredivisie Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/italya-seria/gol-kralligi': {
    title: 'İtalya Serie A Gol Krallığı - Bilyoner',
    description: 'İtalya Serie A gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. İtalya Serie A oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/kocaelispor/fikstur': {
    title: 'Kocaelispor Fikstür - Bilyoner',
    description: 'Kocaelispor fikstür bilgileri futbolun tek adresi Bilyoner’de! Kocaelispor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/eurocup/puan-durumu': {
    title: 'EuroCup Puan Durumu - Bilyoner',
    description: 'EuroCup puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!',
  },
  '/lig-merkezi/ingiltere-premier-lig/puan-durumu': {
    title: 'İngiltere Premier Ligi Puan Durumu - Bilyoner',
    description: 'İngiltere Premier Ligi puan durumu bilgileri Bilyoner’de! İngiltere Premier Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/ingiltere-premier-lig/gol-kralligi': {
    title: 'İngiltere Premier Ligi Gol Krallığı - Bilyoner',
    description: 'İngiltere Premier Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. İngiltere Premier Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/antalyaspor/fikstur': {
    title: 'Antalyaspor Fikstür - Bilyoner',
    description: 'Antalyaspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Antalyaspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/almanya-bundesliga/sari-kirmizi-kartlar': {
    title: 'Almanya Bundesliga Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Almanya Bundesliga oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Almanya Bundesliga sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/sampiyonlar-ligi/gol-kralligi': {
    title: 'Şampiyonlar Ligi Gol Krallığı - Bilyoner',
    description: 'Şampiyonlar Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Şampiyonlar Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/eyupspor/istatistikler': {
    title: 'Eyüpspor İstatistikler - Bilyoner',
    description: 'Eyüpspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Eyüpspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/kayserispor/kadro': {
    title: 'Kayserispor Kadro - Bilyoner',
    description: 'Kayserispor kadro bilgileri Bilyoner’de buluşuyor. Kayserispor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/kayserispor/puan-durumu': {
    title: 'Kayserispor Puan Durumu - Bilyoner',
    description: 'Kayserispor puan durumu tüm detaylarıyla Bilyoner’de! Kayserispor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/tff-3-lig/puan-durumu': {
    title: 'TFF 3. Lig Puan Durumu - Bilyoner',
    description: 'TFF 3. Lig puan durumu bilgileri Bilyoner’de! TFF 3. Lig puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/nba/asist-kralligi': {
    title: 'NBA Asist Krallığı - Bilyoner',
    description: 'NBA asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/karagumruk/kadro': {
    title: 'Karagümrük Kadro - Bilyoner',
    description: 'Karagümrük kadro bilgileri Bilyoner’de buluşuyor. Karagümrük maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/konyaspor/fikstur': {
    title: 'Konyaspor Fikstür - Bilyoner',
    description: 'Konyaspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Konyaspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/konyaspor/istatistikler': {
    title: 'Konyaspor İstatistikler - Bilyoner',
    description: 'Konyaspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Konyaspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/genclerbirligi/istatistikler': {
    title: 'Gençlerbirliği İstatistikler - Bilyoner',
    description: 'Gençlerbirliği istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Gençlerbirliği maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/tff-2-lig/asist-kralligi': {
    title: 'TFF 2. Lig Asist Krallığı - Bilyoner',
    description: 'TFF 2. Lig asist krallığı futbol dünyasının tek adresi Bilyoner’de! TFF 2. Lig maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/turkiye-basketbol-super-ligi/sayi-kralligi': {
    title: 'Türkiye Basketbol Süper Ligi Sayı Krallığı - Bilyoner',
    description: 'Türkiye Basketbol Süper Ligi sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-uluslar-ligi/fikstur': {
    title: 'UEFA Uluslar Ligi Fikstür - Bilyoner',
    description: 'UEFA Uluslar Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. UEFA Uluslar Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/italya-seria/sari-kirmizi-kartlar': {
    title: 'İtalya Serie A Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'İtalya Serie A oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. İtalya Serie A sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/nba/sayi-kralligi': {
    title: 'NBA Sayı Krallığı - Bilyoner',
    description: 'NBA sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/eyupspor/fikstur': {
    title: 'Eyüpspor Fikstür - Bilyoner',
    description: 'Eyüpspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Eyüpspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/samsunspor/istatistikler': {
    title: 'Samsunspor İstatistikler - Bilyoner',
    description: 'Samsunspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Samsunspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/tff-3-lig/sari-kirmizi-kartlar': {
    title: 'TFF 3. Lig Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'TFF 3. Lig oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. TFF 3. Lig sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/goztepe/istatistikler': {
    title: 'Göztepe İstatistikler - Bilyoner',
    description: 'Göztepe istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Göztepe maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/alanyaspor/fikstur': {
    title: 'Alanyaspor Fikstür - Bilyoner',
    description: 'Alanyaspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Alanyaspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-kupasi/fikstur': {
    title: 'Türkiye Kupası Fikstür - Bilyoner',
    description: 'Türkiye Kupası fikstür bilgileri futbolun tek adresi Bilyoner’de. Türkiye Kupası maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/besiktas/istatistikler': {
    title: 'Beşiktaş İstatistikler - Bilyoner',
    description: 'Beşiktaş istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Beşiktaş maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-uluslar-ligi/gol-kralligi': {
    title: 'UEFA Uluslar Ligi Gol Krallığı - Bilyoner',
    description: 'UEFA Uluslar Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. UEFA Uluslar Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/antalyaspor/kadro': {
    title: 'Antalyaspor Kadro - Bilyoner',
    description: 'Antalyaspor kadro bilgileri Bilyoner’de buluşuyor. Antalyaspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/tff-1-lig/gol-kralligi': {
    title: 'TFF 1. Lig Gol Krallığı - Bilyoner',
    description: 'TFF 1. Lig gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. TFF 1. Lig oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/fransa-league-1/fikstur': {
    title: 'Fransa Ligue 1 Fikstür - Bilyoner',
    description: 'Fransa Ligue 1 fikstür bilgileri futbolun tek adresi Bilyoner’de. Fransa Ligue 1 maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/hollanda-eredivisie-ligi/asist-kralligi': {
    title: 'Hollanda Eredivisie Ligi Asist Krallığı - Bilyoner',
    description: 'Hollanda Eredivisie Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! Hollanda Eredivisie Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/turkiye-super-ligi/gol-kralligi': {
    title: 'Türkiye Süper Ligi Gol Krallığı - Bilyoner',
    description: 'Türkiye Süper Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Türkiye Süper Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/kasimpasa/istatistikler': {
    title: 'Kasımpaşa İstatistikler - Bilyoner',
    description: 'Kasımpaşa istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Kasımpaşa maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/turkiye-basketbol-super-ligi/ribaund-kralligi': {
    title: 'Türkiye Basketbol Süper Ligi ribaund Krallığı - Bilyoner',
    description: 'Türkiye Basketbol Süper Ligi ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyuncuların sıralamasını görmek için hemen tıklayın.'
  },
  '/lig-merkezi/turkiye-super-ligi/fikstur': {
    title: 'Türkiye Süper Ligi Fikstür - Bilyoner',
    description: 'Türkiye Süper Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. Türkiye Süper Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fransa-league-1/sari-kirmizi-kartlar': {
    title: 'Fransa Ligue 1 Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Fransa Ligue 1 oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Fransa Ligue 1 sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/besiktas/puan-durumu': {
    title: 'Beşiktaş Puan Durumu - Bilyoner',
    description: 'Beşiktaş puan durumu tüm detaylarıyla Bilyoner’de! Beşiktaş Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/almanya-bundesliga/asist-kralligi': {
    title: 'Almanya Bundesliga Asist Krallığı - Bilyoner',
    description: 'Almanya Bundesliga asist krallığı futbol dünyasının tek adresi Bilyoner’de! Almanya Bundesliga maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/turkiye-super-ligi/asist-kralligi': {
    title: 'Türkiye Süper Ligi Asist Krallığı - Bilyoner',
    description: 'Türkiye Süper Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! Türkiye Süper Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/galatasaray/istatistikler': {
    title: 'Galatasaray İstatistikler - Bilyoner',
    description: 'Galatasaray istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Galatasaray maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/alanyaspor/istatistikler': {
    title: 'Alanyaspor İstatistikler - Bilyoner',
    description: 'Alanyaspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Alanyaspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-avrupa-ligi/gol-kralligi': {
    title: 'UEFA Avrupa Ligi Gol Krallığı - Bilyoner',
    description: 'UEFA Avrupa Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. UEFA Avrupa Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/uefa-uluslar-ligi/sari-kirmizi-kartlar': {
    title: 'UEFA Uluslar Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'UEFA Uluslar Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. UEFA Uluslar Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/sampiyonlar-ligi/puan-durumu': {
    title: 'Şampiyonlar Ligi Puan Durumu - Bilyoner',
    description: 'Şampiyonlar Ligi puan durumu bilgileri Bilyoner’de! Şampiyonlar Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/tff-3-lig/asist-kralligi': {
    title: 'TFF 3. Lig Asist Krallığı - Bilyoner',
    description: 'TFF 3. Lig asist krallığı futbol dünyasının tek adresi Bilyoner’de! TFF 3. Lig maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/genclerbirligi/fikstur': {
    title: 'Gençlerbirliği Fikstür - Bilyoner',
    description: 'Gençlerbirliği fikstür bilgileri futbolun tek adresi Bilyoner’de! Gençlerbirliği maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/karagumruk/fikstur': {
    title: 'Karagümrük Fikstür - Bilyoner',
    description: 'Karagümrük fikstür bilgileri futbolun tek adresi Bilyoner’de! Karagümrük maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/fiba-sampiyonlar-ligi/puan-durumu': {
    title: 'FIBA Şampiyonlar Ligi Puan Durumu - Bilyoner',
    description: 'FIBA Şampiyonlar Ligi puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!'
  },
  '/lig-merkezi/tff-1-lig/fikstur': {
    title: 'TFF 1. Lig Fikstür - Bilyoner',
    description: 'TFF 1. Lig fikstür bilgileri futbolun tek adresi Bilyoner’de. TFF 1. Lig maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/tff-3-lig/fikstur': {
    title: 'TFF 3. Lig Fikstür - Bilyoner',
    description: 'TFF 3. Lig fikstür bilgileri futbolun tek adresi Bilyoner’de. TFF 3. Lig maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/galatasaray/kadro': {
    title: 'Galatasaray Kadro - Bilyoner',
    description: 'Galatasaray kadro bilgileri Bilyoner’de buluşuyor. Galatasaray maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/tff-1-lig/asist-kralligi': {
    title: 'TFF 1. Lig Asist Krallığı - Bilyoner',
    description: 'TFF 1. Lig asist krallığı futbol dünyasının tek adresi Bilyoner’de! TFF 1. Lig maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/genclerbirligi/kadro': {
    title: 'Gençlerbirliği Kadro - Bilyoner',
    description: 'Gençlerbirliği kadro bilgileri Bilyoner’de buluşuyor. Gençlerbirliği maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/samsunspor/fikstur': {
    title: 'Samsunspor Fikstür - Bilyoner',
    description: 'Samsunspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Samsunspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-konferans-ligi/sari-kirmizi-kartlar': {
    title: 'UEFA Konferans Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'UEFA Konferans Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. UEFA Konferans Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/sampiyonlar-ligi/fikstur': {
    title: 'Şampiyonlar Ligi Fikstür - Bilyoner',
    description: 'Şampiyonlar Ligi fikstür bilgileri futbolun tek adresi Bilyoner’de. Şampiyonlar Ligi maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/karagumruk/puan-durumu': {
    title: 'Karagümrük Puan Durumu - Bilyoner',
    description: 'Karagümrük puan durumu tüm detaylarıyla Bilyoner’de! Karagümrük Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/gaziantep-fk/fikstur': {
    title: 'Gaziantep FK Fikstür - Bilyoner',
    description: 'Gaziantep FK fikstür bilgileri futbolun tek adresi Bilyoner’de! Gaziantep FK maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/besiktas/fikstur': {
    title: 'Beşiktaş Fikstür - Bilyoner',
    description: 'Beşiktaş fikstür bilgileri futbolun tek adresi Bilyoner’de! Beşiktaş maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/trabzonspor/fikstur': {
    title: 'Trabzonspor Fikstür - Bilyoner',
    description: 'Trabzonspor fikstür bilgileri futbolun tek adresi Bilyoner’de! Trabzonspor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/almanya-bundesliga/puan-durumu': {
    title: 'Almanya Bundesliga Puan Durumu - Bilyoner',
    description: 'Almanya Bundesliga puan durumu bilgileri Bilyoner’de! Almanya Bundesliga puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/caykur-rizespor/istatistikler': {
    title: 'Çaykur Rizespor İstatistikler - Bilyoner',
    description: 'Çaykur Rizespor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Çaykur Rizespor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/uefa-konferans-ligi/gol-kralligi': {
    title: 'UEFA Konferans Ligi Gol Krallığı - Bilyoner',
    description: 'UEFA Konferans Ligi gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. UEFA Konferans Ligi oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/eurocup/ribaund-kralligi': {
    title: 'EuroCup ribaund Krallığı - Bilyoner',
    description: 'EuroCup ribaund krallığı liderleri Bilyoner’de! Güncel en çok ribaund yapan oyunculrın sıralamasını görmek için hemen tıklayın.'
  },
  '/lig-merkezi/samsunspor/puan-durumu': {
    title: 'Samsunspor Puan Durumu - Bilyoner',
    description: 'Samsunspor puan durumu tüm detaylarıyla Bilyoner’de! Samsunspor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/tff-1-lig/puan-durumu': {
    title: 'TFF 1. Lig Puan Durumu - Bilyoner',
    description: 'TFF 1. Lig puan durumu bilgileri Bilyoner’de! TFF 1. Lig puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/genclerbirligi/puan-durumu': {
    title: 'Gençlerbirliği Puan Durumu - Bilyoner',
    description: 'Gençlerbirliği puan durumu tüm detaylarıyla Bilyoner’de! Gençlerbirliği Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/tff-2-lig/sari-kirmizi-kartlar': {
    title: 'TFF 2. Lig Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'TFF 2. Lig oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. TFF 2. Lig sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/tff-2-lig/puan-durumu': {
    title: 'TFF 2. Lig Puan Durumu - Bilyoner',
    description: 'TFF 2. Lig puan durumu bilgileri Bilyoner’de! TFF 2. Lig puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/eurocup/sayi-kralligi': {
    title: 'EuroCup Sayı Krallığı - Bilyoner',
    description: 'EuroCup sayı krallığı sıralamasını Bilyoner’de keşfedin. Güncel sayı krallığı liderlerini görmek için hemen tıklayın!'
  },
  '/lig-merkezi/fenerbahce/istatistikler': {
    title: 'Fenerbahçe İstatistikler - Bilyoner',
    description: 'Fenerbahçe istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Fenerbahçe maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/tff-2-lig/fikstur': {
    title: 'TFF 2. Lig Fikstür - Bilyoner',
    description: 'TFF 2. Lig fikstür bilgileri futbolun tek adresi Bilyoner’de. TFF 2. Lig maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-uluslar-ligi/asist-kralligi': {
    title: 'UEFA Uluslar Ligi Asist Krallığı - Bilyoner',
    description: 'UEFA Uluslar Ligi asist krallığı futbol dünyasının tek adresi Bilyoner’de! UEFA Uluslar Ligi maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/tff-3-lig/gol-kralligi': {
    title: 'TFF 3. Lig Gol Krallığı - Bilyoner',
    description: 'TFF 3. Lig gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. TFF 3. Lig oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/ispanya-la-liga/puan-durumu': {
    title: 'İspanya La Liga Puan Durumu - Bilyoner',
    description: 'İspanya La Liga puan durumu bilgileri Bilyoner’de! İspanya La Liga puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/goztepe/kadro': {
    title: 'Göztepe Kadro - Bilyoner',
    description: 'Göztepe kadro bilgileri Bilyoner’de buluşuyor. Göztepe maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fiba-sampiyonlar-ligi/asist-kralligi': {
    title: 'FIBA Şampiyonlar Ligi Asist Krallığı - Bilyoner',
    description: 'FIBA Şampiyonlar Ligi asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/gaziantep-fk/kadro': {
    title: 'Gaziantep FK Kadro - Bilyoner',
    description: 'Gaziantep FK kadro bilgileri Bilyoner’de buluşuyor. Gaziantep FK maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/kocaelispor/istatistikler': {
    title: 'Kocaelispor İstatistikler - Bilyoner',
    description: 'Kocaelispor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Kocaelispor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/fenerbahce/fikstur': {
    title: 'Fenerbahçe Fikstür - Bilyoner',
    description: 'Fenerbahçe fikstür bilgileri futbolun tek adresi Bilyoner’de! Fenerbahçe maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/ispanya-la-liga/gol-kralligi': {
    title: 'İspanya La Liga Gol Krallığı - Bilyoner',
    description: 'İspanya La Liga gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. İspanya La Liga oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/turkiye-basketbol-super-ligi/asist-kralligi': {
    title: 'Türkiye Basketbol Süper Ligi Asist Krallığı - Bilyoner',
    description: 'Türkiye Basketbol Süper Ligi asist krallığı tablosu Bilyoner’de! En çok asist yapan basketbol oyuncularını incelemek için hemen tıklayın.'
  },
  '/lig-merkezi/istanbul-basaksehir/kadro': {
    title: 'İstanbul Başakşehir Kadro - Bilyoner',
    description: 'İstanbul Başakşehir kadro bilgileri Bilyoner’de buluşuyor. İstanbul Başakşehir maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fransa-league-1/asist-kralligi': {
    title: 'Fransa Ligue 1 Asist Krallığı - Bilyoner',
    description: 'Fransa Ligue 1 asist krallığı futbol dünyasının tek adresi Bilyoner’de! Fransa Ligue 1 maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/nba/fikstur': {
    title: 'NBA Fikstür - Bilyoner',
    description: 'NBA fikstür bilgileri Bilyoner dünyasında sizi bekliyor. NBA maç programını incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-super-ligi/sari-kirmizi-kartlar': {
    title: 'Türkiye Süper Ligi Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'Türkiye Süper Ligi oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. Türkiye Süper Ligi sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/hollanda-eredivisie-ligi/puan-durumu': {
    title: 'Hollanda Eredivisie Ligi Puan Durumu - Bilyoner',
    description: 'Hollanda Eredivisie Ligi puan durumu bilgileri Bilyoner’de! Hollanda Eredivisie Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/ispanya-la-liga/fikstur': {
    title: 'İspanya La Liga Fikstür - Bilyoner',
    description: 'İspanya La Liga fikstür bilgileri futbolun tek adresi Bilyoner’de. İspanya La Liga maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-basketbol-super-ligi/puan-durumu': {
    title: 'Türkiye Basketbol Süper Ligi Puan Durumu - Bilyoner',
    description: 'Türkiye Basketbol Süper Ligi puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!'
  },
  '/lig-merkezi/trabzonspor/istatistikler': {
    title: 'Trabzonspor İstatistikler - Bilyoner',
    description: 'Trabzonspor istatistiklerini takip ederek gelecek karşılaşmalarda güçlü tahminler yapın! Trabzonspor maç istatistikleri ve daha fazla bilgi Bilyoner’de!'
  },
  '/lig-merkezi/caykur-rizespor/puan-durumu': {
    title: 'Çaykur Rizespor Puan Durumu - Bilyoner',
    description: 'Çaykur Rizespor puan durumu tüm detaylarıyla Bilyoner’de! Çaykur Rizespor Süper Lig ve diğer turnuvalardaki puan durumu Bilyoner’de sizi bekliyor!'
  },
  '/lig-merkezi/istanbul-basaksehir/fikstur': {
    title: 'İstanbul Başakşehir Fikstür - Bilyoner',
    description: 'İstanbul Başakşehir fikstür bilgileri futbolun tek adresi Bilyoner’de! İstanbul Başakşehir maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/kayserispor/fikstur': {
    title: 'Kayserispor Fikstür - Bilyoner',
    description: 'Kayserispor fikstür bilgileri futbolun tek adresi Bilyoner’de! Kayserispor maç fikstürü hakkındaki tüm detayları öğrenmek için hemen tıklayın!'
  },
  '/lig-merkezi/ispanya-la-liga/sari-kirmizi-kartlar': {
    title: 'İspanya La Liga Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'İspanya La Liga oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. İspanya La Liga sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/eyupspor/kadro': {
    title: 'Eyüpspor Kadro - Bilyoner',
    description: 'Eyüpspor kadro bilgileri Bilyoner’de buluşuyor. Eyüpspor maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/uefa-konferans-ligi/puan-durumu': {
    title: 'UEFA Konferans Ligi Puan Durumu - Bilyoner',
    description: 'UEFA Konferans Ligi puan durumu bilgileri Bilyoner’de! UEFA Konferans Ligi puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/besiktas/kadro': {
    title: 'Beşiktaş Kadro - Bilyoner',
    description: 'Beşiktaş kadro bilgileri Bilyoner’de buluşuyor. Beşiktaş maçı kadro ve genel kadro durumunu incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/turkiye-kupasi/gol-kralligi': {
    title: 'Türkiye Kupası Gol Krallığı - Bilyoner',
    description: 'Türkiye Kupası gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. Türkiye Kupası oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/euroleague/puan-durumu': {
    title: 'EuroLeague Puan Durumu - Bilyoner',
    description: 'EuroLeague puan durumu bilgileri Bilyoner’de buluşuyor. Basketbol mücadelesini anbean takip etmek için hemen tıklayın!'
  },
  '/lig-merkezi/fifa-kulupler-dunya-kupasi/puan-durumu': {
    title: 'FIFA Kulüpler Dünya Kupası Puan Durumu - Bilyoner',
    description: 'FIFA Kulüpler Dünya Kupası puan durumu bilgileri Bilyoner’de! FIFA Kulüpler Dünya Kupası puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/fifa-kulupler-dunya-kupasi/fikstur': {
    title: 'FIFA Kulüpler Dünya Kupası Fikstür - Bilyoner',
    description: 'FIFA Kulüpler Dünya Kupası fikstür bilgileri futbolun tek adresi Bilyoner’de. FIFA Kulüpler Dünya Kupası maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/fifa-kulupler-dunya-kupasi/gol-kralligi': {
    title: 'FIFA Kulüpler Dünya Kupası Gol Krallığı - Bilyoner',
    description: 'FIFA Kulüpler Dünya Kupası gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. FIFA Kulüpler Dünya Kupası oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/fifa-kulupler-dunya-kupasi/asist-kralligi': {
    title: 'FIFA Kulüpler Dünya Kupası Asist Krallığı - Bilyoner',
    description: 'FIFA Kulüpler Dünya Kupası asist krallığı futbol dünyasının tek adresi Bilyoner’de! FIFA Kulüpler Dünya Kupası maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/fifa-kulupler-dunya-kupasi/sari-kirmizi-kartlar': {
    title: 'FIFA Kulüpler Dünya Kupası Sarı & Kırmızı Kartlar - Bilyoner',
    description: 'FIFA Kulüpler Dünya Kupası oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. FIFA Kulüpler Dünya Kupası sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/lig-merkezi/2026-fifa-dunya-kupasi/puan-durumu': {
    title: '2026 FIFA Dünya Kupası Puan Durumu - Bilyoner',
    description: '2026 FIFA Dünya Kupası puan durumu bilgileri Bilyoner’de! FIFA Kulüpler Dünya Kupası puan tablosunu takip ederek bu mücadeleye ortak olmak için hemen tıklayın.'
  },
  '/lig-merkezi/2026-fifa-dunya-kupasi/fikstur': {
    title: '2026 FIFA Dünya Kupası Fikstür - Bilyoner',
    description: '2026 FIFA Dünya Kupası fikstür bilgileri futbolun tek adresi Bilyoner’de. 2026 FIFA Dünya Kupası maç programını detaylı olarak incelemek için hemen tıklayın!'
  },
  '/lig-merkezi/2026-fifa-dunya-kupasi/gol-kralligi': {
    title: '2026 FIFA Dünya Kupası Gol Krallığı - Bilyoner',
    description: '2026 FIFA Dünya Kupası gol krallığı futbol dünyasının merkezi Bilyoner’de buluşuyor. 2026 FIFA Dünya Kupası oyuncularının mücadelesini takip etmek için tıklayın!'
  },
  '/lig-merkezi/2026-fifa-dunya-kupasi/asist-kralligi': {
    title: '2026 FIFA Dünya Kupası Asist Krallığı - Bilyoner',
    description: '2026 FIFA Dünya Kupası asist krallığı futbol dünyasının tek adresi Bilyoner’de! 2026 FIFA Dünya Kupası maçları sonucunda belirlenen asist krallığı listesi için tıklayın!'
  },
  '/lig-merkezi/2026-fifa-dunya-kupasi/sari-kirmizi-kartlar': {
    title: '2026 FIFA Dünya Kupası Sarı & Kırmızı Kartlar - Bilyoner',
    description: '2026 FIFA Dünya Kupası oyuncuları sarı ve kırmızı kart bilgileri Bilyoner’de. 2026 FIFA Dünya Kupası sarı ve kırmızı kart alan oyuncu bilgisiyle güçlü tahminler yapmak için tıklayın!'
  },
  '/dunya-kupasi-nostalji': {
    title: 'Dünya Kupası Nostalji Efsane Maçlar ve Anılar - Bilyoner',
    description:
  'Dünya Kupası tarihine yolculuk yapın. Unutulmaz maçlar, efsane oyuncular ve turnuva anılarını tek sayfada Bilyoner ile yeniden hatırlayın.',
  },
};
